import React from 'react';

import useBrandContext from 'contexts/brand.context';
import DisplayMetaDataCard from 'components/display-metadata-card';

const PreviewBrandMetadata = () => {
  const { activeBrand } = useBrandContext();

  return (
    <div>
      <DisplayMetaDataCard
        data={{
          title: 'Brand Keywords',
          values: activeBrand?.brand_keywords?.map((item: any) => {
            return item.name;
          })
        }}
      />
      <DisplayMetaDataCard
        data={{
          title: 'Descriptive Metadata',
          values: activeBrand?.brand_descriptive_metadatas?.map((item: any) => {
            return item.name;
          })
        }}
      />
      <DisplayMetaDataCard
        data={{
          title: 'Business Metadata',
          values: activeBrand?.brand_business_metadatas?.map((item: any) => {
            return item.name;
          })
        }}
      />
    </div>
  );
};

export default PreviewBrandMetadata;
